import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const TimelineComplete: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.5 16C1.5 7.985 7.985 1.5 16 1.5S30.5 7.985 30.5 16 24.015 30.5 16 30.5 1.5 24.015 1.5 16Zm1.714 0c0 7.052 5.734 12.786 12.786 12.786S28.786 23.052 28.786 16 23.052 3.214 16 3.214 3.214 8.948 3.214 16Zm9.662 3.783 8.7-8.7a.867.867 0 0 1 1.213 0c.33.33.33.883 0 1.213l-9.913 9.913-4.482-4.482a.867.867 0 0 1 0-1.213.867.867 0 0 1 1.213 0l3.269 3.27Z"
      clipRule="evenodd"
    />
  </Icon>
);
